import React from 'react';
import {message} from 'antd';
import commonFunHOC from '../commonFunHOC';

export default commonFunHOC(message);